import { AlertTriangle } from "lucide-react";

function tokensLabel(n) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)} M tokens`;
  if (n >= 1_000) return `${Math.round(n / 1_000)} mil tokens`;
  return `${n} tokens`;
}

// Gasto de la IA de este chat (aproximado, con los precios del panel): el acumulado, el último mensaje (y si salió «en frío») y el día de todo el panel.
function SpendLabel({ spend }) {
  const levelClass = spend.level === "alto" ? "text-red-500" : spend.level === "aviso" ? "text-amber-500" : "text-muted-foreground";
  return (
    <span
      data-testid="spend-badge"
      className={levelClass}
      title="Costo aproximado de la IA de este chat. «En frío» = el mensaje tuvo que escribir de nuevo las instrucciones en la memoria de la IA (pasaron más de 5 minutos): cuesta más."
    >
      · Gasto del chat: ≈ ${spend.cost_usd.toFixed(2)} ({tokensLabel(spend.tokens)})
      {spend.last_usd > 0 && ` · último mensaje ≈ $${spend.last_usd.toFixed(2)}${spend.last_cold ? " (en frío)" : ""}`}
      {` · hoy en el panel ≈ $${spend.today_usd.toFixed(2)}`}
    </span>
  );
}

export function ContextUsageBadge({ usage, spend, onCompact, onSuggestTopic }) {
  if (!usage) return null;
  const percent = usage.percent ?? 0;

  const colorClass =
    percent >= 85 ? "text-red-500" : percent >= 60 ? "text-amber-500" : "text-muted-foreground";

  return (
    <div data-testid="context-usage-badge" className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-xs ${colorClass}`}>
      <span>{percent}% del contexto usado</span>
      {spend && typeof spend.cost_usd === "number" && <SpendLabel spend={spend} />}
      {percent >= 85 && (
        <span className="flex items-center gap-2">
          <AlertTriangle className="h-3 w-3" />
          {onCompact && (
            <button
              type="button"
              data-testid="context-usage-suggest-compact"
              onClick={onCompact}
              className="underline underline-offset-2 hover:opacity-80"
            >
              compactar chat
            </button>
          )}
          {onCompact && onSuggestTopic && <span>o</span>}
          {onSuggestTopic && (
            <button
              type="button"
              data-testid="context-usage-suggest-topic"
              onClick={onSuggestTopic}
              className="underline underline-offset-2 hover:opacity-80"
            >
              abrir un tema nuevo
            </button>
          )}
        </span>
      )}
    </div>
  );
}
